import { twMerge } from "tailwind-merge";
import { KYCStatusType } from "@/features/kyc/types.ts";
import { AnimatedEnvelopePass } from "@/components/animations/envelope-olkypass/index.react.tsx";

type HeaderProps = {
  id?: string | number | null;
  status: string;
};
export const HeaderLevelModal = ({ status }: HeaderProps) => {
  const getSrc = () => {
    switch (status) {
      case KYCStatusType.VERIFIED:
        return "/images/olkypass/status_verified.png";
      case KYCStatusType.AUTHENTICATED:
        return "/images/olkypass/status_authenticated.png";
      case KYCStatusType.AUTHENTICATED_BRONZE:
        return "/images/olkypass/status_authenticated_bronze.png";
      case KYCStatusType.AUTHENTICATED_SILVER:
        return "/images/olkypass/status_authenticated_silver.png";
      case KYCStatusType.AUTHENTICATED_GOLD:
        return "/images/olkypass/status_authenticated_Gold.png";

      default:
        break;
    }
  };
  return (
    <>
      <div className="mb-6 flex h-2/5 w-full items-center justify-center overflow-hidden rounded-sm bg-slate-50 md:h-1/2">
        <div className={twMerge("flex h-[200px] w-full items-center justify-center rounded-sm")}>
          <AnimatedEnvelopePass srcImg={getSrc() as string} />
        </div>
      </div>
    </>
  );
};
